/** Place mobile overlay arrows near the image midpoint without covering copy. */
export function mobileOverlayArrowCenter({
    width,
    height,
    headerHeight = 0,
    buttonWidth = 44,
    buttonHeight = 44,
    inset = 12,
    gap = 12,
    blocks = [],
    counter = null,
}) {
    const half = buttonHeight / 2;
    const first = Math.min(inset + half, height / 2);
    const last = Math.max(first, height - inset - half);
    const preferred = Math.max(first, Math.min(last, height / 2 - headerHeight));
    const blocked = [...blocks, ...(counter ? [counter] : [])]
        .filter((rect) => {
            const right = rect.x + rect.width;
            return (
                (rect.x < inset + buttonWidth && right > inset) ||
                (rect.x < width - inset && right > width - inset - buttonWidth)
            );
        })
        .map((rect) => ({
            first: rect.y - half - gap,
            last: rect.y + rect.height + half + gap,
        }));
    const free = (center) => !blocked.some((range) => center > range.first && center < range.last);
    if (free(preferred)) return preferred;
    const candidates = [first, last, ...blocked.flatMap((range) => [range.first, range.last])]
        .filter((center) => center >= first && center <= last && free(center))
        .sort(
            (left, right) =>
                Math.abs(left - preferred) - Math.abs(right - preferred) || left - right,
        );
    // The normal overlay reserves two control rows before copy. If malformed
    // content consumes the entire image, preserve the counter's separate row.
    const fallback = counter ? counter.y + counter.height + gap + half : first;
    return candidates[0] ?? Math.max(first, Math.min(last, fallback));
}
